import React from "react";
import LegalDocument from "../../components/LegalDocument";
import PrivacyMarkdown from "../../content/markdown/legal/PrivacyPolicy.md";

const SectionPrivacyPolicy = () => <LegalDocument markdownPath={PrivacyMarkdown} />;

export default SectionPrivacyPolicy;
